import React from 'react'
import ErrorMessage from '../component/ErrorMessage'
import Header from '../component/layout/Header';
import Footer from '../component/layout/Footer';
import { Row, Col } from 'antd';
import { Link } from 'react-router-dom';

const ErrorMessageContainer = ({match, history, location}) => {
  let params = location.query || {};
  history.push('/biom')
  // if(!params.message) {
  //   history.push('/biom')
  // }

  return (
    <div className="app-root">
      <Header/>
        <div className="container">
          <Row type="flex" justify="center" align="top">
            <Col span={4} align="center">
              <ErrorMessage message={ params.message || "Something went wrong !" }/>
              <Link to="/biom">Return to Home Page</Link>
            </Col>
          </Row>
        </div>
      <Footer/>        
    </div>
  )
}

export default ErrorMessageContainer; 
